import { SECTION_MY_POSTS } from './sections';
export const MY_POSTS_PAGE_TITLE_FONT = `page-${SECTION_MY_POSTS}-titleFont`;
export const MY_POSTS_PAGE_TITLE_COLOR = `page-${SECTION_MY_POSTS}-titleColor`;
export const MY_POSTS_PAGE_TAB_FONT = `page-${SECTION_MY_POSTS}-tabFont`;
export const MY_POSTS_PAGE_TAB_COLOR = `page-${SECTION_MY_POSTS}-tabColor`;
export const MY_POSTS_PAGE_ACTIVE_TAB_COLOR = `page-${SECTION_MY_POSTS}-activeTabColor`;
export const MY_POSTS_PAGE_LINK_FONT = `page-${SECTION_MY_POSTS}-linkFont`;
export const MY_POSTS_PAGE_LINK_COLOR = `page-${SECTION_MY_POSTS}-linkColor`;
export const MY_POSTS_PAGE_BACKGROUND_COLOR = `page-${SECTION_MY_POSTS}-backgroundColor`;
export const MY_POSTS_PAGE_BORDER_COLOR = `page-${SECTION_MY_POSTS}-borderColor`;
export const MY_POSTS_PAGE_BORDER_WIDTH = `page-${SECTION_MY_POSTS}-borderWidth`;
export const MY_POSTS_PAGE_BORDER_WIDTH_DEFAULT_VALUE = 0;
//# sourceMappingURL=my-posts-page.js.map